import React, { useState, useCallback, useEffect, useMemo } from 'react';
import { useController } from 'react-hook-form';
import { TextField, InputAdornment } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';

import { debounce } from 'utils/debounce';
import { ProductsFormFieldNames as FIELD_NAMES } from '../../hooks/constants';
import { SearchProps } from './interface';

export const Search = ({ control }: SearchProps) => {
  const {
    field: { ref, onChange, value, ...searchField },
  } = useController({
    name: FIELD_NAMES.search,
    control,
  });

  const [localValue, setLocalValue] = useState(value || '');

  useEffect(() => {
    setLocalValue(value || '');
  }, [value]);

  const debouncedOnChange = useMemo(
    () => debounce((val: string) => onChange(val), 500),
    [onChange],
  );

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = e.target.value;
      setLocalValue(newValue);
      debouncedOnChange(newValue);
    },
    [debouncedOnChange],
  );

  return (
    <TextField
      {...searchField}
      inputRef={ref}
      fullWidth
      variant="outlined"
      size="small"
      label="Search"
      placeholder="Search by flower, color, occasion..."
      value={localValue}
      onChange={handleChange}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <SearchIcon style={{ width: 20 }} fontSize="small" />
          </InputAdornment>
        ),
      }}
    />
  );
};
